import type { MutableRefObject } from 'react'

export function trySendUnloadBeacon(
  send: () => boolean,
  transcriptSentRef: MutableRefObject<boolean>,
): boolean {
  const accepted = send()
  if (accepted) transcriptSentRef.current = true
  return accepted
}

